<template>
  <div>
    <b-button
      ref="hamburgerBtn"
      v-b-modal.modal-nav
      class="hamburger-container"
      :data-state="state"
      @click="$emit('update:open', !open)"
    >
      <div class="bar bar1" />
      <div class="bar bar2" />
      <div class="bar bar3" />
    </b-button>
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  open: Boolean,
}

@Component
export default class HamburgerButton extends Vue.extend({ props }) {
  get state() {
    return this.open ? 'closed' : 'open'
  }
}
</script>

<style scoped>
.hamburger-container {
  display: inline-block;
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  border: none;
}

.bar {
  background-color: var(--story-foreground);
}

.bar,
.hamburger-container[data-state='open'] .bar {
  width: 28px;
  height: 3px;
  margin: 8px 0;
  transition: 0.4s;
  pointer-events: none;
}

/* Rotate first bar */
.hamburger-container[data-state='closed'] .bar1 {
  -webkit-transform: rotate(-45deg) translate(-9px, 6px);
  transform: rotate(-45deg) translate(-9px, 6px);
}

/* Fade out the second bar */
.hamburger-container[data-state='closed'] .bar2 {
  opacity: 0;
}

/* Rotate last bar */
.hamburger-container[data-state='closed'] .bar3 {
  -webkit-transform: rotate(45deg) translate(-8px, -8px);
  transform: rotate(45deg) translate(-8px, -8px);
}
</style>
